export const ReportStatuses = {
    ReportGenerated: "Report Generated",
    InErrorState: "In Error State",
    AwaitingGeneration: "Awaiting Generation"
}